import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Validators,FormGroup, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TitleService } from 'src/app/shared/Services/title.service';
import { JwtService } from "src/app/shared/Services/jwt.service";
import { CoreService } from "../../Services/core.service";
import { Constant } from "src/app/shared/Constants/constant";
import { StorageService } from "src/app/shared/Services/storage.service";
import { LayoutService } from "src/app/shared/Services/layout.service";
import { UserType } from "src/app/core/Models/constant";
import { HeaderComponent } from "src/app/landing/components/header/header.component";
import { SharedService } from "src/app/shared/Services/shared.service";
import { AuthService } from "src/app/shared/Services/auth.service";
import { BaseComponent } from "src/app/shared/Components/base/base.component";
import { LoggingService } from "src/app/shared/Services/NGLogger/logging-service.service";
import { Subject, catchError, of, takeUntil, tap } from "rxjs";
import { TokenService } from "src/app/shared/Services/token.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
  private componentDestroyed$: Subject<void> = new Subject(); // For unsubscribing when the component is destroyed
  HeadingText = "";
  CurrentItem = "";
  LoginForm!: FormGroup;
  UserData: any;
  IsLogin!: string;
  LoginMsg: any;
  Credentials!: {
    userType: any;
    firstName: any;
    refreshToken: any;
    userImageURL: any;
    refreshTokenExpiryTime: any;
    enterpriseId: number;
    lastName: any;
    emailId: any;
    Phone: any;
    profileImage: any;
    profileImagePath: any;
    profile_status: any;
    userId: any;
    CreatedDate: any;
    UpdatePwdDate: any;
    PasswordUpdateOn: any;
    Role: string;
    CreatedBy: any;
  };
  ShowError!: boolean;
  User!: string;
  UserDataShow!: boolean;
  RouteText!: string;
  rememberMe = false;
  Submitted: boolean = false;
  Users = UserType
  public showPassword: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private jwtService: JwtService,
    private route: ActivatedRoute,
    private coreServices: CoreService,
    private _titleService: TitleService,
    private storageService: StorageService,
    private layoutService: LayoutService,
    private authService:AuthService,
    private loggingService: LoggingService,
    private tokenService: TokenService
  ) {super();
    this.route.paramMap.subscribe((params) => {
      this.RouteText =params.get('type')||'';
      //this.HeadingText =params.get('type') ? Constant.ROUTE_PARAM_HEADINGS[params.get('type') as keyof typeof Constant.ROUTE_PARAM_HEADINGS] || '' : '';
      // TODO New Changes for now 
      this.HeadingText = Constant.ROUTE_PARAM_HEADINGS['supplier' as keyof typeof Constant.ROUTE_PARAM_HEADINGS]
      this.CurrentItem = this.HeadingText;
      this.Submitted = false;
      this.formInit();
    });

    var newTitle = "Login";
    this._titleService.setTitle(newTitle);
  }
  override ngOnDestroy(): void {
    this.Submitted = false;
  }

  override ngOnInit(): void {
    // Initialization logic
    this.layoutService.setShowSidebar(false);
  }

  async onSubmit() {
    try {this.Submitted = true;
      if (this.LoginForm.invalid) {
        return;
      } else {
        await this.logData();
        if (this.UserData) {
          this.IsLogin = "true";
          this.UserDataShow = true;
          let userType = this.jwtService.getUserType();
          if(userType == this.Users.Supplier){
            this.router.navigate(["/supplier/detail"], {
              state: { fromLogin: true }
            }).then(() => {
              this.storageService.reloadOnce();
              // this.formInit();
            });
          }
          else{
            this.router.navigate(["/dashboard"], {
              state: { fromLogin: true }
            }).then(() => {
              this.storageService.reloadOnce();
              // this.formInit();
            });
          }
          
        } else {
          this.LoginMsg = this.UserData.message;
        }
      }
    } catch (error) {
      this.loggingService.captureException(error);
    }
  }



   logData() {
    return new Promise((resolve, reject) => {
    const { email, password, rememberme } = this.LoginForm.controls;
    const originalEmail = email.value;
    const originalPassword = password.value;
    const remember = rememberme.value;
     this.SetStorage(remember,originalEmail);
    email.setValue(originalEmail);
    password.setValue(originalPassword);
    this.coreServices.loginAPI(this.LoginForm.value)
    .pipe(tap(
      async (res) => {
        email.setValue(originalEmail);
        password.setValue(originalPassword);
        if (res.result != undefined) {
          if (res.result.succeeded == false) {
            this.showToastr(res.result.messages[0],'error');
            return;
          }
        }
        if(res.succeeded){
          this.UserData = res.data;
          if (this.UserData) {
              this.storageService.saveUser(this.UserData);
              this.storageService.saveRefExpTime(this.UserData.refreshTokenExpiryTime);
              this.saveUserData();
              this.authService.saveTokenExpiryTime(true);
              this.tokenService.startTokenRefreshTimer();
              resolve(res);
          } else {
              this.LoginMsg = this.UserData.message;
          }
        }
        else
        {
          this.showToastr(res.messages[0],'error');
        }
      }),
      catchError((error) =>{
        this.loggingService.captureException(error);
        return of(null);
      }),
      takeUntil(this.componentDestroyed$)
      )
      .subscribe();
});
}

SetStorage(rememberMe: boolean,originalEmail: string){
  if (rememberMe) {
    this.storageService.saveLogin(originalEmail,"true",this.HeadingText);
} else {
    this.storageService.removeLogin();
}
}

  private saveUserData() {
    const decoded = this.jwtService.getDecodedAccessToken();

    this.Credentials = {
      userType: decoded.UserType,
      firstName: decoded.Name,
      refreshToken: decoded.RefreshToken,
      userImageURL: decoded.UserImageURL,
      refreshTokenExpiryTime: decoded.RefreshTokenExpiryTime,
      enterpriseId: Number(decoded.EnterpriseId),
      lastName: decoded.Surname,
      emailId: decoded.Email,
      Phone: decoded.MobilePhone,
      profileImage: decoded.ProfileImage,
      profileImagePath: decoded.ProfileImagePath,
      profile_status: decoded.ProfileStatus,
      userId: decoded.UserId,
      CreatedDate: decoded.CreatedOn,
      UpdatePwdDate: decoded.CreatedOn,
      PasswordUpdateOn: decoded.PasswordUpdateOn,
      Role: "",
      CreatedBy: decoded.CreatedBy,
    };

    const tempvalue = {
      token: this.UserData.token,
      credentials: this.Credentials,
    };

    this.UserData = {
      success: this.UserData.success,
      message: this.UserData.message,
      data: tempvalue,
    };
  }

  UserType: string = "";
  formInit() {
    const email = this.storageService.getEmail() || "";
    const rememberme = this.storageService.getRememberMe() === 'true';

    this.LoginForm = this.formBuilder.group({
         email: ["", [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,6}(?:\.[a-zA-Z]{2,2})?$')]],
        password: ["", [Validators.required]],
        rememberme: [""],
        userType: [this.HeadingText],
    });
    this.LoginMsg ="";
    const storedRoute = this.storageService.getRoute() || "";

    if (this.HeadingText === storedRoute) {
        this.LoginForm.patchValue({
            email: email,
            rememberme: rememberme,
        });
    }
}

emailValidator(control: { value: string; }) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,})?$/;
  if (control.value && !emailPattern.test(control.value)) {
    return { invalidEmail: true };
  }
  return null;
}

  clearData() {
    this.LoginForm.reset();
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}

